import { clearAllSpatialEaseOnKeyframe } from "./keyframes";
import { notify } from "./notifications";

export const generalInputValidation = (
	comp: any,
	selectedLayers: string | any[]
) => {
	if (!comp) {
		alert(notify.noComp);
		return;
	}
	if (selectedLayers.length === 0) {
		alert(notify.noLayer);
		return;
	}
};

/**
 * Takes a keyframeable property in Adobe After Effects and returns an array of indices for the selected keyframes.
 *
 * @param prop - The keyframeable property to validate.
 * @returns An array of indices for the selected keyframes, or an empty array if the selected keyframes are invalid.
 */
export const validateSelectedKeyframes = (prop: any) => {
	let selectedKeys = prop.selectedKeys;
	if (!selectedKeys || selectedKeys.length < 1 || prop.numKeys < 1) {
		//alert(notify.noKeyframes)
		return [];
	}
	let originIndex = selectedKeys[selectedKeys.length - 2];
	let destinationIndex = selectedKeys[selectedKeys.length - 1];

	if (prop.matchName.includes("Mask Path")) {
		//alert(notify.maskPath)
		return [];
	} else if (selectedKeys.length === 1) {
		// alert(notify.elasticNoDelta);
		return selectedKeys;
	} else {
		if (
			prop.propertyValueType == PropertyValueType.ThreeD_SPATIAL ||
			prop.propertyValueType == PropertyValueType.TwoD_SPATIAL
		) {
			clearAllSpatialEaseOnKeyframe(prop, originIndex);
			clearAllSpatialEaseOnKeyframe(prop, destinationIndex);
		}
		return selectedKeys;
	}
};

export const validateSelectedKeyframesDistribute = (prop: any) => {
	let selectedKeys = prop.selectedKeys;
	if (!selectedKeys || selectedKeys.length <= 1 || prop.numKeys < 2) {
		//alert(notify.noKeyframes)
		return [];
	}
	let originIndex = selectedKeys[selectedKeys.length - 2];
	let destinationIndex = selectedKeys[selectedKeys.length - 1];

	if (prop.matchName.includes("Mask Path")) {
		//alert(notify.maskPath)
		return [];
	} else if (prop.keyValue(destinationIndex) === prop.keyValue(originIndex)) {
		//alert(notify.elasticNoDelta)
		return [];
	} else {
		return selectedKeys;
	}
};

//TODO: 0 breaks AE, check for more details and fix below.
export const validateCubicBezierX = (vals: number[]) => {
	if (vals[0] >= 1) vals[0] = 0.999;
	if (vals[2] >= 1) vals[2] = 0.999;
	if (vals[0] < 0.001) vals[0] = 0.001;
	if (vals[2] < 0.001) vals[2] = 0.001;
	return vals;
};

export const elasticKeyframeValidation = (prop: any) => {
	let selectedIndices = prop.selectedKeys;
	if (!selectedIndices || selectedIndices.length <= 1 || prop.numKeys < 2) {
		//alert(`${notify.noKeyframes} Found at: ${prop.name}`)
		return [];
	}
	var originIndex = selectedIndices[selectedIndices.length - 2];
	var destinationIndex = selectedIndices[selectedIndices.length - 1];
	if (prop.keyValue(destinationIndex) === prop.keyValue(originIndex)) {
		//alert(`${notify.elasticNoDelta} Found at: ${prop.name}`)
		return [];
	}
	if (selectedIndices[selectedIndices.length - 1]) return selectedIndices;
};
